import { render } from "./StepMobileHeader.vue?vue&type=template&id=ff50a428&scoped=true&ts=true"
import script from "./StepMobileHeader.vue?vue&type=script&lang=ts"
export * from "./StepMobileHeader.vue?vue&type=script&lang=ts"

import "./StepMobileHeader.vue?vue&type=style&index=0&id=ff50a428&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff50a428"]])

export default __exports__